/**
 * @author：
 * @update：
 * @description：
 **/
import Vue from 'vue'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import {
    BarChart,
    LineChart
} from 'echarts/charts';
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
    TitleComponent,
    TooltipComponent,
    GridComponent
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import {
    CanvasRenderer
} from 'echarts/renderers';
import {orderGet} from "@/api/order";


import {echartsGet,echartsPayGet,echartsUserGet} from '@/api/echarts'
// 注册必须的组件
echarts.use(
    [TitleComponent, TooltipComponent, GridComponent, BarChart, LineChart, CanvasRenderer]
);
Vue.prototype.$echarts = echarts
export default {
    data() {
        return {
            dataTime:[],//日期
            pv_countNum:[],//浏览量
            visitor_countNum:[],//访客数
            avg_visit_timeNum:[],//人均访问时长
            echartsUserNum:[],//日新增用户
            echartsPayNum:[],//付费率
            new_visitor_ratioNum:[],//留存率
        };
    },
    // 自定义方法
    methods: {
        //获取数据
        getList() {
            this.loading = true;
            this.$ajax.get(echartsGet, {
                metrics:'pv_count,visitor_count,avg_visit_time,new_visitor_ratio'
            }).then((res) => {
                if (res.status === 200) {// 成功了
                    for (let i = 0; i < res.data.body.data[0].result.items[0].length; i++){
                        this.dataTime.unshift(res.data.body.data[0].result.items[0][i][0]);
                        //浏览量
                        if (res.data.body.data[0].result.items[1][i][0] == '--'){
                            res.data.body.data[0].result.items[1][i][0] = 0
                        }
                        this.pv_countNum.unshift(res.data.body.data[0].result.items[1][i][0]);
                        //访客数
                        if (res.data.body.data[0].result.items[1][i][1] == '--'){
                            res.data.body.data[0].result.items[1][i][1] = 0
                        }
                        this.visitor_countNum.unshift(res.data.body.data[0].result.items[1][i][1]);
                        //人均访问时长
                        if (res.data.body.data[0].result.items[1][i][2] == '--'){
                            res.data.body.data[0].result.items[1][i][2] = 0
                        }
                        this.avg_visit_timeNum.unshift(res.data.body.data[0].result.items[1][i][2]);
                        //留存率
                        if (res.data.body.data[0].result.items[1][i][3] == '--'){
                            res.data.body.data[0].result.items[1][i][3] = 100
                        }
                        this.new_visitor_ratioNum.unshift(100 - res.data.body.data[0].result.items[1][i][3])
                    }
                    this.activeEcharts();
                    this.increaseEcharts();
                    this.timeEcharts();
                    this.activeRateEcharts();
                    this.keepEcharts();
                    this.payEcharts();
                }
            }, (err) => {
                console.log(err);
            })
            this.$ajax.get(echartsPayGet, {}).then((res) => {
                if (res.status === 200) {// 成功了
                    this.echartsPayNum = res.data.values.reverse();
                    this.payEcharts();
                }
            }, (err) => {
                console.log(err);
            })
            this.$ajax.get(echartsUserGet, {}).then((res) => {
                if (res.status === 200) {// 成功了
                    this.echartsUserNum = res.data.values.reverse();
                    this.activeRateEcharts();
                }
            }, (err) => {
                console.log(err);
            })


        },
        activeEcharts() {
            this.active = this.$echarts.init(this.$refs.active);
            let option = {
                color: ['#005BFF'],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.dataTime,
                    axisLabel: {
                        interval:0,
                        rotate:40
                    },
                },
                yAxis: {
                    type: 'value',
                },
                series: [{
                    data: this.pv_countNum,
                    type: 'line',
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: 'rgba(0, 91, 255, 0.5)'},
                                    {offset: 1, color: 'rgba(0, 91, 255, 0)'}
                                ]
                            )
                        }
                    },
                }]
            };
            this.active.setOption(option);
        },
        increaseEcharts() {
            this.increase = this.$echarts.init(this.$refs.increase);
            let option = {
                color: ['#005BFF'],
                barGap: '10%',
                barCategoryGap: '70%',
                // title: {
                //     text: "按需引入",
                // },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.dataTime,
                    axisLabel: {
                        interval:0,
                        rotate:40
                    },
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.visitor_countNum,
                    type: 'bar',
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(0, 91, 255, 0.03)'
                    }
                }]
            };
            this.increase.setOption(option);
        },
        timeEcharts() {
            this.time = this.$echarts.init(this.$refs.time);
            let option = {
                color: ['#00BD83'],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.dataTime,
                    axisLabel: {
                        interval:0,
                        rotate:40
                    },
                },
                yAxis: {
                    type: 'value',
                },
                series: [{
                    data: this.avg_visit_timeNum,
                    type: 'line',
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: 'rgba(0, 189, 131, 0.5)'},
                                    {offset: 1, color: 'rgba(0, 189, 131, 0)'}
                                ]
                            )
                        }
                    },
                }]
            };
            this.time.setOption(option);
        },
        activeRateEcharts() {
            this.activeRate = this.$echarts.init(this.$refs.activeRate);
            let option = {
                color: ['#00BD83'],
                barGap: '10%',
                barCategoryGap: '70%',
                // title: {
                //     text: "按需引入",
                // },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.dataTime,
                    axisLabel: {
                        interval:0,
                        rotate:40
                    },
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.echartsUserNum,
                    type: 'bar',
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(0, 189, 131, 0.05)'
                    }
                }]
            };
            this.activeRate.setOption(option);
        },
        payEcharts() {
            this.pay = this.$echarts.init(this.$refs.pay);
            let option = {
                color: ['rgba(95, 122, 194, 1)'],
                barGap: '10%',
                barCategoryGap: '70%',
                // title: {
                //     text: "按需引入",
                // },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.dataTime,
                    axisLabel: {
                        interval:0,
                        rotate:40
                    },
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.echartsPayNum,
                    type: 'bar',
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(95, 122, 194, 0.06)'
                    }
                }]
            };
            this.pay.setOption(option);
        },
        keepEcharts() {
            this.keep = this.$echarts.init(this.$refs.keep);
            let option = {
                color: ['#798CFD'],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.dataTime,
                    axisLabel: {
                        interval:0,
                        rotate:40
                    },
                },
                yAxis: {
                    type: 'value',
                },
                series: [{
                    data: this.new_visitor_ratioNum,
                    type: 'line',
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: 'rgba(121, 140, 253, 0.5)'},
                                    {offset: 1, color: 'rgba(121, 140, 253, 0)'}
                                ]
                            )
                        }
                    },
                }]
            };
            this.keep.setOption(option);
        },
    },
    // 数据观察监听
    watch: {},
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        this.getList();
    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {
        //做到每个图表根据屏幕变化而自适应宽高
        window.addEventListener("resize", () => {
            this.active.resize();
            this.increase.resize();
            this.time.resize();
            this.activeRate.resize();
            this.pay.resize();
            this.keep.resize();
        });
    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
